import api from './api';

export type SincronizacaoStatus = 'INICIADO' | 'SUCESSO' | 'PARCIAL' | 'ERRO';
export type SincronizacaoTipo = 'FULL' | 'INCREMENTAL';
export type SincronizacaoEntidade = 'EMPRESA' | 'PRODUTO' | 'USUARIO' | 'TODOS';

export interface SincronizacaoLog {
  id: number;
  tipo: SincronizacaoTipo;
  entidade: SincronizacaoEntidade;
  status: SincronizacaoStatus;
  iniciado_em: string | null;
  finalizado_em: string | null;
  duracao_formatada: string;
  total_processados: number;
  total_erros: number;
  mensagem: string | null;
}

export interface SincronizacaoLogDetalhe extends SincronizacaoLog {
  duracao: number | null;
  resumo_empresas: { criadas: number; atualizadas: number; erros: number; total: number };
  resumo_produtos: { criados: number; atualizados: number; erros: number; total: number };
  resumo_usuarios: { criados: number; atualizados: number; erros: number; total: number };
}

export interface SincronizacaoEstatisticas {
  total_logs: number;
  sincronizacoes_hoje: number;
  sucesso_hoje: number;
  erros_hoje: number;
  sincronizacoes_semana: number;
  sincronizacoes_mes: number;
  taxa_sucesso: number;
  por_status: Record<string, number>;
  ultima_sincronizacao_sucesso: SincronizacaoLog | null;
  totais_sincronizados: {
    empresas_criadas: number;
    empresas_atualizadas: number;
    produtos_criados: number;
    produtos_atualizados: number;
    usuarios_criados: number;
    usuarios_atualizados: number;
    total_erros: number;
  };
}

export interface SincronizacaoLogFiltros {
  data_inicio?: string;
  data_fim?: string;
  status?: string;
  tipo?: string;
  entidade?: string;
}

const ENDPOINT = '/sincronizacao-logs';

const sincronizacaoLogService = {
  async listar(filtros: SincronizacaoLogFiltros = {}): Promise<SincronizacaoLog[]> {
    const response = await api.get<SincronizacaoLog[]>(ENDPOINT, { params: filtros });
    return response.data;
  },
  async buscarPorId(id: number): Promise<SincronizacaoLogDetalhe> {
    const response = await api.get<SincronizacaoLogDetalhe>(`${ENDPOINT}/${id}`);
    return response.data;
  },
  async estatisticas(): Promise<SincronizacaoEstatisticas> {
    const response = await api.get<SincronizacaoEstatisticas>(`${ENDPOINT}/estatisticas`);
    return response.data;
  },
};

export default sincronizacaoLogService;
